import React, { Fragment, useContext, useState } from 'react';
import { Button } from '@material-ui/core';
import styled from 'styled-components';

import ReactQuill from 'react-quill';
import {
  ApprovalEditor,
  ApprovalHeaderTextContainer,
} from '../UnsignedApproval';
import defaults from '../../../../translations/en.json';
import { DiscardModal, DiscardModalContext } from '../DiscardModal';
import { ReviewContainerContext } from './ReviewContainerContext';
import { modules, formats, RTF_BLANK_STRING } from '../../../../constants';

import 'react-quill/dist/quill.snow.css';

const ReviewButtons = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  gap: 0.5vw;
  justify-content: left;
`;

export const ReviewInput = React.memo(({ onSubmit, renderTextInput }) => {
  const { index, length, onNext, onPrev, showNext, showPrev } = useContext(
    ReviewContainerContext,
  );

  const [reviewText, setReviewText] = useState('');
  const [discardOpen, openDiscardModal] = useState(false);

  const hasText = reviewText !== '' && reviewText !== RTF_BLANK_STRING;

  const discardAndSkip = () => {
    setReviewText('');
    if (showNext) {
      onNext();
    } else if (showPrev) {
      onPrev();
    }
  };

  return (
    <Fragment>
      <ReviewButtons>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          disabled={!renderTextInput}
          onClick={() => {
            setReviewText('');
            onSubmit(reviewText);
          }}
        >
          {defaults.REVIEW_COMPLETE}
        </Button>
        {showPrev && (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            disabled={hasText}
            onClick={onPrev}
          >
            Previous
          </Button>
        )}
        {showNext && (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            disabled={hasText}
            onClick={onNext}
          >
            {defaults.NEXT}
          </Button>
        )}
        <div
          style={{
            position: 'relative',
            alignSelf: 'center',
            border: '1px solid',
            borderRadius: '1vh',
            padding: '0.75vh',
          }}
        >
          {index + 1} of {length}
        </div>
        {hasText && (
          <DiscardModalContext.Provider
            value={{ open: discardOpen, setOpen: openDiscardModal }}
          >
            <DiscardModal onConfirm={discardAndSkip} />
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => openDiscardModal(true)}
            >
              {defaults.DISCARD_TEXT}
            </Button>
          </DiscardModalContext.Provider>
        )}
      </ReviewButtons>

      {renderTextInput && (
        <Fragment>
          <ApprovalHeaderTextContainer style={{ justifySelf: 'flex-end' }}>
            {defaults.Review_Notes}
          </ApprovalHeaderTextContainer>
          <ApprovalEditor>
            <ReactQuill
              theme="snow"
              onChange={(html) => setReviewText(html)}
              value={reviewText}
              modules={modules}
              formats={formats}
              placeholder="type something"
            />
          </ApprovalEditor>
        </Fragment>
      )}
    </Fragment>
  );
});
